/*********************
* vendors:
* sweetalert
* smoothscroll-polyfill
*********************/
const APP = {
    timerAppDefault: 5400, // 90 Minutes
    timerPauseDefault: 900, // 15 Minutes
    adminMail: 'mail@i-e-profil.de',
    sentencesCount: 0,
    onReady() {
        this.sentencesCount = fields.length;
        APP.inputFieldsProcessor();
        APP.progressBar();
        APP.prepareLocalStorage();
        APP.timerApp     = COOKIE.get({name: 'timer-app'}) === '' ? APP.timerAppDefault : parseInt(COOKIE.get({name: 'timer-app'}));
        APP.timerPause   = COOKIE.get({name: 'timer-pause'}) === '' ? APP.timerPauseDefault : parseInt(COOKIE.get({name: 'timer-pause'}));
        let timerAppNode = document.getElementById('timer-app');
        if (timerAppNode !== null) {
            // Check if a timestamp is already set, if not set one
            APP.startDateTime = COOKIE.get({name: 'start-date-time'}) === '' ? Date.now() : parseInt(COOKIE.get({name: 'start-date-time'}));
            COOKIE.set({
                name:  'start-date-time',
                value: APP.startDateTime,
                days:  1
            });
            // Start the timer
            APP.startTimerApp();
        }
    },
    prepareLocalStorage() {
        // "fields" is a constant build in PHP
        fields.forEach(field => {
            localStorage.setItem(`question-${field.id}`, field.question);
        });
    },
    storeInputsInLocalStorage() {
        // Save all inputs in Local Storages
        let inputs = document.querySelectorAll('.js-app-input');
        inputs.forEach(node => {
            let isSpan        = node.tagName === 'SPAN' ? true : false;
            let text          = isSpan ? node.textContent : node.value ;
            let currentLength = text.length;
            let maxLength     = node.getAttribute('maxlength');
            localStorage.setItem(`answer-${node.dataset.questionId}`, text);
            if (maxLength === null) return;
            maxLength = parseInt(maxLength);
            if (currentLength >= maxLength) {
                localStorage.setItem(`answer-${node.dataset.questionId}`, text.substring(0, maxLength));
            }
        });
    },
    storeInputsInDBCache() {
        // Stores the input encrypted into a db table
        let getUrl     = window.location;
        let baseUrl    = getUrl.protocol + '//' + getUrl.hostname + '/';
        var serialized = [ 
            `code=${ COOKIE.get({name: 'code'}) }`,
            `count=${ APP.sentencesCount }`,
            'nonce=' + encodeURIComponent(ieNonce)
        ];
        var ii = 1;
        for (ii; ii <= APP.sentencesCount; ii++) {
            serialized.push(encodeURIComponent(`answer-${ii}`) + '=' + encodeURIComponent(localStorage.getItem(`answer-${ii}`)));
            serialized.push(encodeURIComponent(`question-${ii}`) + '=' + encodeURIComponent(localStorage.getItem(`question-${ii}`)));
        } 
        let formData  = serialized.join('&');
        let handler   = 'handler.XHR.php?handler=app-cache';
        let xhr       = new XMLHttpRequest();
        xhr.open('POST', baseUrl + 'wp-content/themes/atlas-novus-child/inc/' + handler, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = (e) => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    switch (xhr.response) {
                        case 'success' :
                            // success
                            console.log('success');
                            break;
                        case 'error' :
                            // error
                            console.log('error 1');
                            break;
                        default :
                            // default
                            console.log('default');
                            break;
                    }
                } else {
                    // error
                    console.log('error 2');
                }
            }
        };
        xhr.onerror = (e) => {
            // error
            console.log('error 3');
        };
        xhr.send(formData);
        console.log(xhr);
    },
    /*********************
    * Check
    *********************/
    check() {
        APP.storeInputsInLocalStorage();
        APP.storeInputsInDBCache();
        let nonRequiredFilled = nonRequiredFields.length - APP.progressBar().nonRequiredMissing.length;
        let required          = document.querySelectorAll('.js-app-input[data-required="true"]');
        var error             = 0;
        required.forEach(node => {
            if (!node.value) error++;
        });
        if (error === 0 && nonRequiredFilled >= 30) {
            APP.send();
        } else if (error === 0 && nonRequiredFilled < 30) {
            let text       = document.createElement('p');
            text.innerHTML = lang === 'de' ? `Bitte vervollständigen Sie die noch nicht beantworteten Satzanfänge. Es müssen mindestens 30 Sätze beantwortet sein, um Ihren Fragebogen auswerten zu können (dies betrifft: ${APP.progressBar().nonRequiredMissing.join('., ')}).`
                                           : `Please complete the sentence beginnings that have not yet been answered. At least 30 sentences must be answered in order to be able to evaluate your questionnaire (this concerns: ${APP.progressBar().nonRequiredMissing.join('., ')}).`;
            text.classList.add('swal-text', 'mb-0', 'mt-0');
            /*********************
            * 
            * 
            * 
            * Ihre Angaben sind unvollständig
            * 
            * 
            * 
            *********************/
            swal({
                title:               lang === 'de' ? 'Ihre Angaben sind unvollständig' : 'Your information is incomplete',
                content:             text,
                icon:                'warning',
                closeOnClickOutside: false,
                closeOnEsc:          false,
                buttons:             'ok'
            });
        // Required fileds not filled found
        } else {
            let text       = document.createElement('p');
            var swalTextTrue  = lang === 'de' ? `Bitte vervollständigen Sie die Angaben zur Person (dies betrifft: ${APP.progressBar().requiredMissingLabels.join(', ')}).<br><br> Bitte schauen Sie, ob Sie die noch nicht beantworteten Satzanfänge vervollständigen möchten (dies betrifft: ${APP.progressBar().nonRequiredMissing.join('., ')}).`
                                              : `Please complete the personal information (this concerns: ${APP.progressBar().requiredMissingLabels.join(', ')}).<br><br> Please see if you would like to complete the sentence starters that have not yet been answered (this concerns: ${APP.progressBar().nonRequiredMissing.join('., ')}).`;
            var swalTextFalse = lang === 'de' ? `Bitte vervollständigen Sie die Angaben zur Person (dies betrifft: <br><br>${APP.progressBar().requiredMissingLabels.join(',<br> ')}).`
                                              : `Please complete the personal information (this concerns: ${APP.progressBar().requiredMissingLabels.join(', ')}).`;
            text.innerHTML = APP.progressBar().percentage !== 100 ? swalTextTrue : swalTextFalse;
            text.classList.add('swal-text', 'mb-0', 'mt-0');
            /*********************
            * 
            * 
            * 
            * Ihre Angaben sind unvollständig
            * 
            * 
            * 
            *********************/
            swal({
                title:               lang === 'de' ? 'Ihre Angaben sind unvollständig' : 'Your information is incomplete',
                content:             text,
                icon:                'warning',
                closeOnClickOutside: false,
                closeOnEsc:          false,
                buttons:             'ok'
            });
        }
    },
    /*********************
    * Send
    *********************/
    send() {
        let getUrl     = window.location;
        let baseUrl    = getUrl.protocol + '//' + getUrl.hostname + '/';
        var text       = document.createElement('p');
        text.innerHTML = lang === 'de' ? `Mit dem Abschicken willigen Sie in die Verarbeitung und Speicherung Ihrer Daten zur Auswertung durch das ZIE&T, in Verantwortung Dr. Thomas Binder, und von ihm beauftragter, zur Verschwiegenheit verpflichteter Expert*innen ein.<br><br>
                                          Die Daten dürfen zum Erstellen eines persönlichen Auswertungsberichts verwendet werden. Ebenso können sie zur Qualitätssicherung und wissenschaftlichen Forschung verwendet werden, sofern die Angaben zur Person von inhaltlichen Antworten getrennt werden, so dass keinerlei Rückschluss auf Personen möglich ist.<br><br>
                                          Die Verarbeitung Ihrer Daten erfolgt im Rahmen der Erfüllung unserer vertraglichen Pflichten. Rechtsgrundlage für die Verarbeitung der Daten ist Art. 6 Abs. 1 lit. b DSGVO.<br><br>
                                          Im Übrigen weisen wir auf die geltenden <a href='${baseUrl}datenschutz/' target='_blank'>Datenschutzhinweise</a> hin.`
                                       : `By sending this form, you agree to the processing and storage of your data for evaluation by CED&T, under the responsibility of Dr. Thomas Binder, and by experts commissioned by him and bound to secrecy.<br><br>
                                          The data may be used to create a personal evaluation report. They may also be used for quality assurance and scientific research, provided that the personal details are separated from the answers to the questionnaire, so that it is not possible to draw any conclusions about individuals.<br><br>
                                          The processing of your data takes place within the framework of the fulfillment of our contractual obligations. The legal basis for the processing of the data is Art. 6 para. 1 lit. b DSGVO.<br><br>
                                          For the rest, we refer to the applicable data protection information.<br><br>`;
        text.classList.add('swal-text', 'mb-0', 'mt-0');
        /*********************
        * 
        * 
        * 
        * Einwilligungserklärung
        * 
        * 
        * 
        *********************/
        swal({
            title:   lang === 'de' ? 'Datenschutzhinweis zur Speicherung und Verarbeitung personenbezogener Daten' : 'Data protection notice on the storage and processing of personal data',
            content: text,
            closeOnClickOutside: false,
            closeOnEsc: false,
            buttons: {
                cancel: {
                    text:       lang === 'de' ? 'abbrechen' : 'cancel',
                    value:      null,
                    visible:    true,
                    className:  '',
                    closeModal: true,
                },
                confirm: {
                    text:       lang === 'de' ? 'abschicken' : 'submit',
                    value:      true,
                    visible:    true,
                    className:  '',
                    closeModal: true
                }
            }
        }).then(accept => {
            if (accept) {
                OVERLAY.loading();
                var serialized = [ 
                    `code=${ COOKIE.get({name: 'code'}) }`,
                    `count=${ APP.sentencesCount }`,
                    'nonce=' + encodeURIComponent(ieNonce)
                ];
                var ii = 1;
                for (ii; ii <= APP.sentencesCount; ii++) {
                    serialized.push(encodeURIComponent(`answer-${ii}`) + '=' + encodeURIComponent(localStorage.getItem(`answer-${ii}`)));
                    serialized.push(encodeURIComponent(`question-${ii}`) + '=' + encodeURIComponent(localStorage.getItem(`question-${ii}`)));
                } 
                let formData  = serialized.join('&');
                let handler   = 'handler.XHR.php?handler=app-data';
                let xhr       = new XMLHttpRequest();
                let errorText = document.createElement('p');
                errorText.innerHTML = lang === 'de' ? `Es tut uns Leid, aber es gab einen internen Server-Fehler. Bitte informieren Sie uns über diesen Fehler mit dem obenstehenden Fehler-Code unter:<br> <strong class='block no-wrap mt-100 mb-100'><a href='mailto:${APP.adminMail}'>${APP.adminMail}</a></strong> Ihre Eingaben bleiben bis zum nächsten Login gespeichert.` 
                                                    : `We're sorry, but there was an internal server error. Please inform us about this error using the above error code at:<br> <strong class='block no-wrap mt-100 mb-100'><a href='mailto:${APP.adminMail}'> ${APP.adminMail}</a></strong> Your entries will be saved until you log in again.`;
                errorText.classList.add('swal-text', 'mb-0', 'mt-0');
                xhr.open('POST', baseUrl + 'wp-content/themes/atlas-novus-child/inc/' + handler, true);
                xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                xhr.onload = (e) => {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            switch (xhr.response) {
                                case 'success' :
                                    var text       = document.createElement('p');
                                    text.innerHTML = lang === 'de' ? `Wir haben Ihre Antworten erhalten und werden diese nun auswerten.<br><br>
                                                                      Die Standardauswertungszeit bis zur Erstellung und Übermittlung Ihres Ich-Entwicklungs-Profils beträgt 6 Wochen. Vielen Dank!`
                                                                   : `We have received your responses and will now evaluate them.<br><br>
                                                                      The standard evaluation time to create and submit your Ego-Development-Profile is 6 weeks. Thank you very much!`;
                                    text.classList.add('swal-text', 'mb-0', 'mt-0');
                                    /*********************
                                    * 
                                    * 
                                    * 
                                    * Erfolgreich übermittelt!
                                    * 
                                    * 
                                    * 
                                    *********************/
                                    swal({
                                        title:  lang === 'de' ? 'Erfolgreich übermittelt!' : 'Successfully submitted!',
                                        content: text,
                                        icon:   'success',
                                        button: lang === 'de' ? 'Super!' : 'Great!',
                                        closeOnClickOutside: false,
                                        closeOnEsc: false
                                    })
                                    .then(click => {
                                        if (click) {
                                            APP.deleteData({ local: true });
                                            window.location.href = 'https://www.i-e-profil.de/';
                                        }
                                    });
                                    break;
                                case 'error' :
                                    /*********************
                                    * 
                                    * 
                                    * 
                                    * Error
                                    * 
                                    * 
                                    * 
                                    *********************/
                                    swal({
                                        title:   lang === 'de' ? 'Ups! Es gab einen Server-Fehler' : 'Yikes! There was a server error',
                                        text:    'Code: 01',
                                        content: errorText,
                                        icon:    'error',
                                        button:  lang === 'de' ? 'verstanden' : 'got it',
                                        closeOnClickOutside: false,
                                        closeOnEsc: false
                                    })
                                    .then(click => {
                                        if (click) APP.deleteData({ local: false });
                                    });
                                    break;
                                default :
                                    /*********************
                                    * 
                                    * 
                                    * 
                                    * Error
                                    * 
                                    * 
                                    * 
                                    *********************/
                                    swal({
                                        title:   lang === 'de' ? 'Ups! Es gab einen Server-Fehler' : 'Yikes! There was a server error',
                                        text:    'Code: 02',
                                        content: errorText,
                                        icon:    'error',
                                        button:  lang === 'de' ? 'verstanden' : 'got it',
                                        closeOnClickOutside: false,
                                        closeOnEsc: false
                                    })
                                    .then(click => {
                                        if (click) APP.deleteData({ local: false });
                                    });
                                    break;
                            }
                        } else {
                            /*********************
                            * 
                            * 
                            * 
                            * Error
                            * 
                            * 
                            * 
                            *********************/
                            swal({
                                title:   lang === 'de' ? 'Ups! Es gab einen Server-Fehler' : 'Yikes! There was a server error',
                                text:    'Code: 03',
                                content: errorText,
                                icon:    'error',
                                button:  lang === 'de' ? 'verstanden' : 'got it',
                                closeOnClickOutside: false,
                                closeOnEsc: false
                            }).then(click => {
                                if (click) APP.deleteData({ local: false });
                            });
                        }
                        document.getElementById('overlay-loading').remove();
                    }
                };
                xhr.onerror = (e) => {
                    document.getElementById('overlay-loading').remove();
                    /*********************
                    * 
                    * 
                    * 
                    * Error
                    * 
                    * 
                    * 
                    *********************/
                    swal({
                        title:   lang === 'de' ? 'Ups! Es gab einen Server-Fehler' : 'Yikes! There was a server error',
                        text:    'Code: 04',
                        content: errorText,
                        icon:    'error',
                        button:  lang === 'de' ? 'verstanden' : 'got it',
                        closeOnClickOutside: false,
                        closeOnEsc: false
                    }).then(click => {
                        if (click) APP.deleteData({ local: false });
                    });
                };
                xhr.send(formData);
                console.log(xhr);
            }
        });
    },
    step({step, xhrNode = 'xhr-app'}) {
        APP.storeInputsInLocalStorage();
        APP.storeInputsInDBCache();
        OVERLAY.loading();
        COOKIE.set({
            name:  'step',
            value: step,
            days:  1
        });
        if (CSS.supports('scroll-behavior', 'smooth')) {
            window.scrollTo({ 
                top: 0, 
                behavior: 'smooth' 
            });
        } else {
            // macOS Safari workaround using 'smoothscroll-polyfill'
            window.scroll({ 
                top: 0, 
                left: 0, 
                behavior: 'smooth' 
            });       
        }
        // Standard function calls on Next or Prev Buttons
        var calls = [APP.inputFieldsProcessor, APP.progressBar];
        // Add startTimerApp() if timer isn't init yet, the same for the timestamp
        if (COOKIE.get({name: 'timer-app'}) === '' && COOKIE.get({name: 'start-date-time'}) === '') {
            APP.timerApp = APP.timerAppDefault;
            calls.push(APP.startTimerApp);
            APP.startDateTime = Date.now();
            COOKIE.set({
                name:  'start-date-time',
                value: APP.startDateTime,
                days:  1
            });
        }
        // Delay for a visual effect
        setTimeout(() => {
            XHR.load({
                nodeIds: [xhrNode],
                functionCall: calls
            });
            document.getElementById('overlay-loading').remove();
        }, 1000);
    },
    inputFieldsProcessor() {
        let inputs = document.querySelectorAll('.js-app-input');
        inputs.forEach(node => {
            let isSpan = node.tagName === 'SPAN' ? true : false;
            // Fill and Build Input Fields if Data is available
            let storage = localStorage.getItem(`answer-${node.dataset.questionId}`);
            if (storage !== null && storage !== '') {
                APP.progressBar();
                if (isSpan) {
                    node.innerText = storage;  
                } else {
                    node.value = storage;  
                }
                APP.counterLogic({
                    node:   node,
                    isSpan: isSpan
                });
            }
            // Input Eventlistener
            node.addEventListener('input', event => {
                APP.counterLogic({
                    node:   node,
                    isSpan: isSpan
                });
            });
            // Paste block
            node.addEventListener('paste', event => {
                event.preventDefault();
                var text       = document.createElement('p');
                text.innerHTML = lang === 'de' ? `Um ein möglichst präzises Ergebnis zu gewährleisten, verhindert die Anwendung das Einfügen von Text. Dies dient dazu, die Antwortzeit realistisch zu halten, da diese ebenfalls ein Faktor bei der Auswertung ist.`
                                               : `To ensure the most accurate result possible, the application prevents text from being pasted. This measure helps maintain a realistic response time, which is also a factor in the evaluation.`;
                text.classList.add('swal-text', 'mb-0', 'mt-0');
                swal({
                    title:  lang == 'de' ? 'Einfügen nicht möglich' : 'Pasting not possible',
                    content: text,
                    icon:   'error',
                    button: lang == 'de' ? 'ok' : 'ok',
                    closeOnClickOutside: true,
                    closeOnEsc: true
                });
            });
        });
    },
    counterLogic({node, isSpan}) {
        var text = isSpan ? node.textContent : node.value ;
        var maxLength = node.getAttribute('maxlength');
        if (maxLength === null) return;
        maxLength = parseInt(maxLength);
        let currentLength = text.length;
        let counter       = document.querySelector('[data-counter="'+ node.dataset.questionId +'"]');
        (currentLength > 0 && isSpan) ? node.classList.add('no-border', 'no-block') : node.classList.remove('no-border', 'no-block');
        (currentLength > 350) ? counter.classList.add('display') : counter.classList.remove('display');
        var counterTextTrue  = lang === 'de' ? `${currentLength} von max. ${maxLength} Zeichen`
                                             : `${currentLength} of max. ${maxLength} characters`;
        var counterTextFalse = lang === 'de' ? `${currentLength}/450 Zeichen - ab rot wird nicht mehr gespeichert`
                                             : `${currentLength}/450 characters - red is no longer saved`;
        counter.innerHTML = currentLength <= 450 && lang ? counterTextTrue : counterTextFalse;
        if (currentLength > maxLength) {
            node.innerHTML = text.substring(0, maxLength) + '<span class="red-text">' + text.substring(maxLength, currentLength) + '</span>';
            UTILS.putCursorAtEnd({input: node});
        }
    },
    progressBar() {
        var progress = 0;
        var ii       = 1;
        var requiredMissing       = [];
        var requiredMissingLabels = [];
        var nonRequiredMissing       = [];
        var nonRequiredMissingLabels = [];
        for (ii; ii <= APP.sentencesCount; ii++) {
            let storage = localStorage.getItem(`answer-${ii}`);
            if (storage !== null && storage !== '') progress++;
            nonRequiredFields.forEach(field => {
                if ((storage === null || storage === '') && ii === field.id) nonRequiredMissing.push(ii);
                if ((storage === null || storage === '') && ii === field.id) nonRequiredMissingLabels.push(localStorage.getItem(`question-${ii}`));
            });
            requiredFields.forEach(field => {
                if ((storage === null || storage === '') && ii === field.id) requiredMissing.push(ii);
                if ((storage === null || storage === '') && ii === field.id) requiredMissingLabels.push(localStorage.getItem(`question-${ii}`));
            });
        }
        var percentage = 100 / APP.sentencesCount * progress;
        let number = document.getElementById('percentage-number');
        let bar    = document.getElementById('percentage-bar');
        if (number === null || bar === null) return;
        number.innerHTML = lang === 'de' ? `Fortschritt ${Math.ceil(percentage)}%` : `Progress ${Math.ceil(percentage)}%`;
        bar.style.right = `calc(100% - ${percentage}%)`;
        let object = {
            percentage:               percentage,
            requiredMissing:          requiredMissing,
            requiredMissingLabels:    requiredMissingLabels,
            nonRequiredMissing:       nonRequiredMissing,
            nonRequiredMissingLabels: nonRequiredMissingLabels
        };
        return object;
    },
    startTimerApp() {
        // Make the interval call available in a bigger scope to clear it in itself
        APP.decreaseTimerAppInterval = setInterval(APP.decreaseTimerApp, 1000); // 1 Sekunde
    },
    decreaseTimerApp() {
        APP.timerApp -= 1;
        switch (true) {
            // Ends the app when the timestamp (in milliseconds) expires
            case (Date.now() > APP.startDateTime + (APP.timerAppDefault * 1000)) :
                APP.endTimerApp();
                break;
            // Half time
            case (APP.timerApp === (APP.timerAppDefault / 2)) :
                var text       = document.createElement('p');
                text.innerHTML = lang === 'de' ? `Bitte vervollständigen Sie die Sätze innerhalb des verfügbaren Zeitrahmens.<br><br>Falls Sie eine kurze Unterbrechung benötigen, ist eine Pause von max. 15 min vorgesehen. Danach werden Sie automatisch zum Fragebogen zurückgeleitet.<br><br><strong>Wichtig:</strong> Falls Sie die Fragen nicht in dem vorgesehenen Zeitrahmen beantworten, gehen Ihre Eingaben leider verloren.`
                                               : `Please complete the sentences within the time available.<br><br>If you need a short break, a break of max. 15 minutes is provided. You will then be automatically redirected to the questionnaire.<br><br><strong>Important:</strong> If you do not answer the questions within the allotted time frame, your entries will unfortunately be lost.`;
                text.classList.add('swal-text', 'mb-0', 'mt-0');
                /*********************
                * 
                * 
                * 
                * Halbzeit
                * 
                * 
                * 
                *********************/
                swal({
                    title:  lang === 'de' ? 'Halbzeit!' : 'Halftime!',
                    content: text,
                    icon:   'info',
                    button: lang === 'de' ? 'verstanden' : 'got it',
                    closeOnClickOutside: false,
                    closeOnEsc: false
                });
                break;
            // 10 minutes left
            case (APP.timerApp === 600) :
                var text       = document.createElement('p');
                text.innerHTML = lang === 'de' ? `Bitte vervollständigen Sie die Sätze innerhalb des verfügbaren Zeitrahmens.<br><br>Falls Sie eine kurze Unterbrechung benötigen, ist eine Pause von max. 15 min vorgesehen. Danach werden Sie automatisch zum Fragebogen zurückgeleitet.<br><br><strong>Wichtig:</strong> Falls Sie die Fragen nicht in dem vorgesehenen Zeitrahmen beantworten, gehen Ihre Eingaben leider verloren.`
                                               : `Please complete the sentences within the time available.<br><br>If you need a short break, a break of max. 15 minutes is provided. You will then be automatically redirected to the questionnaire.<br><br><strong>Important:</strong> If you do not answer the questions within the allotted time frame, your entries will unfortunately be lost.`;
                text.classList.add('swal-text', 'mb-0', 'mt-0');
                /*********************
                * 
                * 
                * 
                * 10 minutes left
                * 
                * 
                * 
                *********************/
                swal({
                    title:  lang === 'de' ? '10 Minuten noch' : '10 minutes left',
                    content: text,
                    icon:   'info',
                    button: lang === 'de' ? 'verstanden' : 'got it',
                    closeOnClickOutside: false,
                    closeOnEsc: false
                });
                break;
            // Decreases the counter
            case (APP.timerApp > 0) :
                // Get the difference if user switched focus
                let difference = (Math.ceil((Date.now() - APP.startDateTime) / 1000) + APP.timerApp) - APP.timerAppDefault;
                APP.timerApp = APP.timerApp - difference;
                let timerAppNode = document.getElementById('timer-app');
                timerAppNode.innerText = lang === 'de' ? `${Math.ceil(APP.timerApp / 60)} Minuten verbleibend` : `${Math.ceil(APP.timerApp / 60)} minutes remaining`;
                COOKIE.set({
                    name:  `timer-app`,
                    value: APP.timerApp,
                    days:  1
                });
                break;
            // Ends the app when no time is left
            case (APP.timerApp < 1) :
                APP.endTimerApp();
                break;
            // Ends the app as default
            default :
                APP.endTimerApp();
                break;
        }
    },
    endTimerApp() {
        // Stop the interval
        clearInterval(APP.decreaseTimerAppInterval);
        /*********************
        * 
        * 
        * 
        * Sitzung ist abgelaufen
        * 
        * 
        * 
        *********************/
        swal({
            title:  lang === 'de' ? 'Ihre Sitzung ist abgelaufen.' : 'Your session has expired.',
            text:   lang === 'de' ? 'Ihre Eingaben gehen leider verloren. Sie können die Sätze einmal erneut ergänzen. Bitte achten Sie auf den gegebenen Zeitrahmen.' : 'Unfortunately, your entries will be lost. You can complete the sentences again. Please pay attention to the given time frame.',
            icon:   'warning',
            button: lang === 'de' ? 'verstanden' : 'got it',
            closeOnClickOutside: false,
            closeOnEsc: false
        }).then(reload => {
            if (reload) {
                APP.deleteData({ local: true })
            }
        });
    },
    startTimerPause() {
        clearInterval(APP.decreaseTimerAppInterval);
        let container      = document.createElement('div');
        let text           = document.createElement('p');
        let timerPauseNode = document.createElement('div');
        text.innerHTML     = lang === 'de' ? 'Bitte vervollständigen Sie die Sätze innerhalb des verfügbaren Zeitrahmens.<br><br>Falls Sie Sie eine kurze Unterbrechung benötigen, ist eine Pause von max. 15 min vorgesehen. Danach werden Sie automatisch zum Fragebogen zurückgeleitet.'
                                           : 'Please complete the sentences within the available time frame.<br><br>If you need a short break, a break of max. 15 minutes is provided. You will then be automatically redirected to the questionnaire.';
        timerPauseNode.id  = 'timer-pause';
        timerPauseNode.innerText = lang === 'de' ? `${Math.ceil(APP.timerPause / 60)} Minuten verbleibend` : `${Math.ceil(APP.timerPause / 60)} minutes remaining`;
        timerPauseNode.classList.add('text-big', 'mb-200');
        text.classList.add('swal-text', 'mb-0');
        container.appendChild(timerPauseNode);
        container.appendChild(text);
        APP.decreaseTimerPauseInterval = setInterval(APP.decreaseTimerPause, 1000); // 1 Sekunde
        /*********************
        * 
        * 
        * 
        * Pause
        * 
        * 
        * 
        *********************/
        swal({
            title:  'Pause',
            content: container,
            icon:   'info',
            button: lang === 'de' ? 'fortfahren' : 'continue',
            closeOnClickOutside: false,
            closeOnEsc: false
        }).then(continueApp => {
            if (continueApp) {
                APP.startTimerApp();
                clearInterval(APP.decreaseTimerPauseInterval);
            }
        });
    },
    decreaseTimerPause() {
        APP.timerPause -= 1;
        if (APP.timerPause > 0) {
            let timerPauseNode = document.getElementById('timer-pause');
            timerPauseNode.innerText = lang === 'de' ? `${Math.ceil(APP.timerPause / 60)} Minuten verbleibend` : `${Math.ceil(APP.timerPause / 60)} minutes remaining`;
            COOKIE.set({
                name:  `timer-pause`,
                value: APP.timerPause,
                days:  1
            });
            // Add pause time to initial start date
            APP.startDateTime += 1000; // 1 second in milliseconds
            COOKIE.set({
                name:  `start-date-time`,
                value: APP.startDateTime,
                days:  1
            });
        } else {
            // Stop the interval
            clearInterval(APP.decreaseTimerPauseInterval);
            /*********************
            * 
            * 
            * 
            * Pause ist abgelaufen
            * 
            * 
            * 
            *********************/
            swal({
                title:   lang === 'de' ? 'Ihre Pausenzeit ist abgelaufen.' : 'Your break time has expired.',
                text:    lang === 'de' ? 'In wenigen Sekunden geht es weiter.' : 'It will continue in a few seconds.',
                icon:    'warning',
                buttons: false,
                timer:   2500,
                closeOnClickOutside: false,
                closeOnEsc: false
            }).then(() => {
                APP.startTimerApp();
            });
        }
    },
    /**
    * @local {bool} - delete localStorage
    */
    deleteData({local, cookies = true, reload = true}) {
        if (local) localStorage.clear(); // deletes all items in local storage
        if (cookies) {
            COOKIE.delete({name: 'start-date-time'});
            COOKIE.delete({name: 'timer-app'});
            COOKIE.delete({name: 'timer-pause'});
            COOKIE.delete({name: 'step'});
            COOKIE.delete({name: 'code'});            
        }
        if (reload) window.location.reload();
    }
}